import React, { useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { tabselected } from "../../consts.js";
import ConversationInsight from "./conversation-insight";
import ConversationTranscript from "./conversation-transcript";
import { useThemeMode } from "../../components/theme/index.jsx";
import S3_Util from "../../utils/s3-folder-creation/s3-folder-utilty.js";
import Utils from "../../utils.js";

function Conversation() {
    const navigate = useNavigate();
    const location = useLocation();

    const { colours, FONT } = useThemeMode();

    const [params] = useSearchParams();
    const [conversationId, setConversationId] = React.useState(params.get("id") || "");
    const [selectedTab, setSelectedTab] = React.useState("Conversation insight");
    const [alerts, setAlerts] = React.useState([]);

    useEffect(() => {
        if (!conversationId) {
            returnToCampaigns();
        }
        const getConversationFromS3 = async () => {
            const audioTranscripts = await S3_Util.getS3File("transcripts/" + conversationId + ".json");
            console.log("audioTranscripts = ", audioTranscripts);
        }
        (async () => await fetchAlerts())();
        /**
         * Disabled for now as we are not using this S3 file
         */
        // getConversationFromS3();
    }, [conversationId]);

    // on location search update get the new conversation ny id
    useEffect(() => {
        setSelectedTab("Conversation insight");
        if(conversationId !== params.get("id")) {
            setConversationId(params.get("id"));
        }
    }, [location.search]);

    const returnToCampaigns = () => {
        navigate("/campaigns");
    }

    // const returnToCampaign = () => {
    //     navigate("/campaign?id=" + campaignData.id);
    // }

    const fetchAlerts = async () => {
        try {
          let response = await Utils.genericList("listAlerts", { filter: { conversation: { eq: conversationId } } });
    
          const alertsData = response?.data?.listAlerts?.items ? response?.data?.listAlerts?.items : [];
          while (response?.data?.listAlerts?.nextToken) {
            response = await Utils.genericList("listAlerts", { filter: { conversation: { eq: conversationId } }, nextToken: response?.data?.listAlerts?.nextToken });
            alertsData.push(...response?.data?.listAlerts?.items);
          }
    
          setAlerts(alertsData);
        } catch (error) {
          console.log("fetch alerts error => ", error);
          return [];
        }
    };

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <Grid
                display="flex"
                flexDirection="row"
                flexWrap="wrap"
                borderBottom={colours.dividergraybottomborder}
                paddingX={1}
                alignItems="center"
                gap={1}
            >
                <Typography
                    component="div"
                    display="flex"
                    flexDirection="row"
                    marginRight="auto"
                    alignItems={{ xs: 'end', sm: 'normal' }}
                >
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Conversation insight", colours, FONT)}
                        onClick={() => setSelectedTab("Conversation insight")}
                    >
                        Conversation Insight
                    </Typography>
                    <Typography component="div"
                        sx={tabselected(selectedTab === "Transcript", colours, FONT)}
                        onClick={() => setSelectedTab("Transcript")}
                    >
                        Transcript
                    </Typography>
                </Typography>
                {/* <Typography component="div" sx={{ order: { xs: '-1', sm: '0' }, paddingTop: { xs: 1, sm: 0 } }}>
                    <Button
                        variant="contained"
                        onClick={() => {}}
                        startIcon={<FeatherIcon icon="upload" size={20} />}
                    >
                        Upload
                    </Button>
                </Typography> */}
            </Grid>

            {selectedTab === "Conversation insight" ? <ConversationInsight conversationId={conversationId} alertsData={alerts}/> : null}
            {selectedTab === "Transcript" ? <ConversationTranscript conversationId={conversationId} alertsData={alerts}/> : null}
        </Grid>
    );
}

export default Conversation;
